module.exports = __webpack_public_path__ + "static/media/landingImage4.ce55c5e0.png";